// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kb-labfront.container svg.arrow circle.red {
  fill: #e81e32;
}
.kb-labfront.container svg.arrow circle.amber {
  fill: #FF6600;
}
.kb-labfront.container svg.arrow circle.green {
  fill: #01b366;
}
.kb-labfront.container svg.arrow g.arrow-paths {
  stroke: none;
  fill: #fff;
  transform-origin: center;
}
.kb-labfront.container svg.arrow g.arrow-paths.diagonal {
  transform: rotate(45deg);
}
.kb-labfront.container svg.arrow g.arrow-paths.down {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/components/pageElements/Arrow/Arrow.scss"],"names":[],"mappings":"AAGM;EACE,aAAA;AAFR;AAIM;EACE,aAAA;AAFR;AAIM;EACE,aAAA;AAFR;AAKI;EACE,YAAA;EACA,UAAA;EACA,wBAAA;AAHN;AAIM;EACE,wBAAA;AAFR;AAIM;EACE,yBAAA;AAFR","sourcesContent":[".kb-labfront.container {\n  svg.arrow {\n    circle {\n      &.red {\n        fill: #e81e32;\n      }\n      &.amber {\n        fill: #FF6600;\n      }\n      &.green {\n        fill: #01b366;\n      }\n    }\n    g.arrow-paths {\n      stroke: none;\n      fill: #fff;\n      transform-origin: center;\n      &.diagonal {\n        transform: rotate(45deg);\n      }\n      &.down {\n        transform: rotate(180deg);\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
